// Single source of truth for length unit conversions.
// All factors expressed as: 1 unit = X meters.

export type LengthUnitKey =
  | "mm"
  | "cm"
  | "inch"
  | "hath"
  | "foot"
  | "yard"
  | "meter"
  | "chain"
  | "km"
  | "mile";

export interface LengthUnit {
  key: LengthUnitKey;
  en: string;
  bn: string;
  shortEn: string;
  shortBn: string;
  meters: number; // 1 unit = X meters
  note?: { en: string; bn: string };
}

export const LENGTH_UNITS: LengthUnit[] = [
  { key: "mm",    en: "Millimeter",  bn: "মিলিমিটার",   shortEn: "mm",    shortBn: "মিমি",   meters: 0.001 },
  { key: "cm",    en: "Centimeter",  bn: "সেন্টিমিটার", shortEn: "cm",    shortBn: "সেমি",   meters: 0.01 },
  { key: "inch",  en: "Inch",        bn: "ইঞ্চি",       shortEn: "in",    shortBn: "ইঞ্চি",  meters: 0.0254 },
  { key: "hath",  en: "Hath (Cubit)",bn: "হাত",         shortEn: "hath",  shortBn: "হাত",    meters: 0.4572,
    note: { en: "Traditional BD cubit ≈ 1.5 feet", bn: "ঐতিহ্যবাহী হাত ≈ ১.৫ ফুট" } },
  { key: "foot",  en: "Foot",        bn: "ফুট",         shortEn: "ft",    shortBn: "ফুট",    meters: 0.3048 },
  { key: "yard",  en: "Yard",        bn: "গজ",          shortEn: "yd",    shortBn: "গজ",     meters: 0.9144 },
  { key: "meter", en: "Meter",       bn: "মিটার",       shortEn: "m",     shortBn: "মিটার",  meters: 1 },
  { key: "chain", en: "Chain",       bn: "চেইন",        shortEn: "ch",    shortBn: "চেইন",   meters: 20.1168,
    note: { en: "Used in BD land surveys (1 chain = 66 ft)", bn: "বাংলাদেশের জরিপে (১ চেইন = ৬৬ ফুট)" } },
  { key: "km",    en: "Kilometer",   bn: "কিলোমিটার",   shortEn: "km",    shortBn: "কিমি",   meters: 1000 },
  { key: "mile",  en: "Mile",        bn: "মাইল",        shortEn: "mi",    shortBn: "মাইল",   meters: 1609.344 },
];

export const LENGTH_UNIT_MAP: Record<LengthUnitKey, LengthUnit> =
  Object.fromEntries(LENGTH_UNITS.map((u) => [u.key, u])) as Record<LengthUnitKey, LengthUnit>;
